module.exports = __webpack_public_path__ + "static/network5-4f8fb7d7b22234888dcfcb8aa593f80b.jpg";